import { BreadcrumbsProps, Breadcrumbs as CssModulesBreadcrumbs } from '@sunwebgroup/uds-ui/breadcrumbs'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/breadcrumbs' instead.
 */
export default Object.assign(
  styled(CssModulesBreadcrumbs)<BreadcrumbsProps>``,
  { displayName: 'Breadcrumbs' },
)
